import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import qs from 'query-string';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import MenusBurger from './MenusBurger';
import AttachmentButton from '../../components/buttons/Attachment';
import BackButton from '../../components/buttons/BackButton';
import EditFormsButton from '../../components/menus/EditFormsButton';
import OtherActions from '../../components/menus/OtherActions';
import OtherTasks from '../../components/menus/OtherTasks';
import PrintButton from '../../components/menus/Print';
import { useFormSelector } from '../../custom-hooks';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getUserContext } from '../../form-designer/selectors/common.selectors';
import { anyFormHasSelectedSubGrids } from '../../form-designer/selectors/runtime.selectors';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
  },
});

const showPrintMenu = (entityType) => {
  const entitiesWithoutPrintMenu = [
    'SDT_DOC_TYPE',
    'CUT_COURSE_TYPE',
    'SS_REG_SUBSCRIPTION',
    'SS_PRINT_CTL_JOB',
    'IAC_INTERNAL_ACTOR',
    'PSN_PERSON',
    'SS_SDC_DOCUMENT_PRTL',
    'SS_DOC_BATCH_PRINT',
  ];
  return !entitiesWithoutPrintMenu.includes(entityType);
};

const hasDetailOption = (entityType, item) => {
  const entitiesToAvoid = [
    'SS_RESPONSE',
    'SS_AUDIT_PROGRAM',
    'SS_DOC_PACKET',
    'SS_FNP_FINISHED_PRODUCT',
    'SS_REGULATORY',
    'SS_NC_PRTL',
    'SS_CAPA_PRTL',
    'SS_AUDIT_PRTL',
    'SS_RESP_PRTL',
    'SS_SUPPLIER_REQUEST_PRTL',
    'SS_VMSR',
    'SS_RECEIPT',
    'SS_PSN_REVIEW',
    'SS_FAR',
  ];
  return !(entitiesToAvoid.includes(entityType) && item.id === 'DETAIL');
};

const hasDowloadAllAttachmentsOption = (entityType, item) => {
  const entitiesToAvoid = ['SS_AUDITEE', 'SS_DOC_SHARE_REVIEW'];
  return !(entitiesToAvoid.includes(entityType) && item.id === 'DOWNLOAD_ALL_ATTACHMENTS');
};

const filterMenuItem = (entityType) => (item) =>
  hasDetailOption(entityType, item) && hasDowloadAllAttachmentsOption(entityType, item);

const Menus = () => {
  const classes = useStyles();
  const location = useLocation();
  const qsParams = qs.parse(location.search) || {};
  const { entityType } = qsParams;

  const { isArchiveMode } = useSelector((state) => state.auth);
  const anyFormHasSubGrids = useSelector(anyFormHasSelectedSubGrids);
  const userContext = useFormSelector(getUserContext);
  const { isMobileDevice } = useWindowDimensions();

  const hasFormsDesignPermission = userContext?.f_CurrentRights?.FORMS_DESIGN;
  const showEditButtons = hasFormsDesignPermission && !isArchiveMode;
  const isMinifiedVersion = anyFormHasSubGrids || isMobileDevice;

  const getMenu = (menuComponent) => (
    <Grid
      className={isMinifiedVersion ? classes.fullWidth : ''}
      item
      ui-ta={getUITA('FormMenuButton')}
    >
      {menuComponent}
    </Grid>
  );

  const menus = (
    <div>
      <BackButton />
      <Grid container spacing={1} ui-ta={getUITA('FormMenuContainer')}>
        {!isArchiveMode && getMenu(<OtherTasks />)}
        {!isArchiveMode && getMenu(<OtherActions />)}
        {showPrintMenu(entityType) &&
          getMenu(<PrintButton entityType={entityType} filterMenuItem={filterMenuItem} />)}
        {isMinifiedVersion ? (
          <>
            {showEditButtons && getMenu(<EditFormsButton />)}
            {!isArchiveMode && getMenu(<AttachmentButton fullWidth={isMinifiedVersion} />)}
          </>
        ) : (
          <>
            {!isArchiveMode && getMenu(<AttachmentButton fullWidth={isMinifiedVersion} />)}
            {showEditButtons && getMenu(<EditFormsButton />)}
          </>
        )}
      </Grid>
    </div>
  );

  return anyFormHasSubGrids && !isMobileDevice ? <MenusBurger menus={menus} /> : menus;
};

export default Menus;
